import React from 'react';

import Alumni1 from '../../assets/images/alumni1.png';
import Alumni2 from '../../assets/images/alumni2.png';
import Alumni3 from '../../assets/images/alumni3.png';
import Alumni4 from '../../assets/images/alumni4.png';
import Alumni5 from '../../assets/images/alumni5.png';
import Alumni6 from '../../assets/images/alumni6.png';

import AlumniSvg1 from '../../assets/svgs/alumni1.svg';
import AlumniSvg2 from '../../assets/svgs/alumni2.svg';

import AlumnaTag from './AlumnaTag';

function Alumni() {
  return (
    <div className="content">
      <div className="w-full h-[520px] flex gap-3">

        {/* Col 1 - stacked photo + svg */}
        <div className="flex flex-col gap-3 w-[15%]">
          <div className="flex-1 rounded-2xl relative overflow-hidden group shadow-lg">
            <img src={Alumni1} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
            <AlumnaTag name="Samuel" post="Partnership Officer" />
          </div>
          <div className="h-[130px] rounded-2xl overflow-hidden bg-primary flex items-center justify-center shadow flex-shrink-0">
            <img src={AlumniSvg1} alt="" className="w-full h-full object-cover opacity-90" />
          </div>
        </div>

        {/* Col 2 - tall hero */}
        <div className="w-[28%] h-full rounded-2xl relative overflow-hidden group shadow-xl">
          <img src={Alumni2} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
          <div className="absolute top-5 left-5 bg-primary text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full">Alumni</div>
        </div>

        {/* Col 3 - 2x2 grid */}
        <div className="flex flex-col gap-3 w-[30%]">
          <div className="flex gap-3 flex-1">
            <div className="flex-1 rounded-2xl relative overflow-hidden group shadow-lg">
              <img src={Alumni3} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
              <AlumnaTag name="Ebuka" post="Relationship Management Officer" />
            </div>
            <div className="flex-1 rounded-2xl overflow-hidden bg-primary/90 flex items-center justify-center shadow">
              <img src={AlumniSvg2} alt="" className="w-full h-full object-contain p-4 opacity-90" />
            </div>
          </div>
          <div className="flex-1 rounded-2xl relative overflow-hidden group shadow-lg">
            <img src={Alumni4} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          </div>
        </div>

        {/* Col 4 - tall feature */}
        <div className="w-[27%] h-full rounded-2xl relative overflow-hidden group shadow-xl">
          <img src={Alumni5} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
          <AlumnaTag name="Seun" post="Relationship Management Officer" />
        </div>

        {/* Col 5 - small photo */}
        <div className="flex-1 h-full rounded-2xl relative overflow-hidden group shadow-lg">
          <img src={Alumni6} alt="Alumni" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
        </div>

      </div>
    </div>
  );
}

export default Alumni;
